<template>
    <div>
        <h5 v-lang.useful_links></h5>
        <ul class="useful_links">
            <li><router-link to="/site/rooms" v-lang.habitaciones></router-link></li>
            <li><router-link to="/site/contact" v-lang.contacto></router-link></li>
            <li><router-link to="/site/blog" v-lang.blog></router-link></li>
            <!--<li><router-link to="/site/book" v-lang.book></router-link></li>-->
        </ul>
    </div>
</template>

<script>
    export default {
        created : function(){
            var self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
            });
        },
        beforeDestroy : function(){
            this.unsubscribe();
        }
    }
</script>


// WEBPACK FOOTER //
// Links.vue?1afee0a6